// extracted by mini-css-extract-plugin
export default {"range":"styles_range__8e9ER","input":"styles_input__KmBmQ","icon":"styles_icon__2jj8L"};